import { Navigate, Outlet } from 'react-router-dom';
import { useAppSelector } from '../redux/hooks';

interface ProtectedRouteProps {
  requireAdmin?: boolean;
}

const ProtectedRoute = ({ requireAdmin = false }: ProtectedRouteProps) => {
  const { isAuthenticated, user } = useAppSelector((state) => state.auth);

  if (!isAuthenticated || !user) {
    return <Navigate to="/signin" replace />;
  }

  // User needs to be either an admin or a filler to access the HR dashboard
  const canAccess = user.hrDashboardAdmin || user.hrDashboardFiller;

  if (!canAccess) {
    console.warn('HR access denied', {
      userId: user.id,
      userRole: user.role,
      hrDashboardAdmin: user.hrDashboardAdmin,
      hrDashboardFiller: user.hrDashboardFiller,
    });
    return <Navigate to="/unauthorized" replace />;
  }

  // For admin routes, check if user is specifically an admin
  if (requireAdmin && !user.hrDashboardAdmin) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;